<p>menu works!</p>
<nav class="navbar navbar-expand-lg bg-body-tertiary" data-bs-theme="dark">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="">Gestão Fotografo</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" routerLink="">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/sobre'">Sobre</a>
        </li>
        <li class="nav-item">          
          <a class="nav-link" [routerLink]="'/portfolio'">Portfolio</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/servicos'">Serviços</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/blog'">Blog</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/contato'">Contato</a>
        </li>
      </ul>
    </div>
  </div>
</nav>


<!--
<div class="nav-fixed" style="z-index: 1001 !important">
    <nav class="nav-extended">
        <div class="nav-wrapper">
          <a href="#" class="brand-logo">Logo</a>
          <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>

          <ul id="nav-mobile" class="right hide-on-med-and-down">
           
            <li><a [routerLink]="'/contato'" class="flow-text">Contato</a></li>
            <li><a [routerLink]="'/home'" class="flow-text">Home25</a></li>
            <li><a [routerLink]="'/login'" class="flow-text">Login</a></li>
            <li><a [routerLink]="'/sobre'" class="flow-text">Sobre</a></li>
          </ul>
        </div>
        
      </nav>
    
      <ul class="sidenav" id="mobile-demo">    
        

        <li><a href="contato.html" >Contato</a></li>
        <li><a href="home.html" >Home</a></li>
        <li><a href="login.html" >Login</a></li>
        <li><a href="sobre.html" >Sobre</a></li>
      </ul>
    
      
</div>
-->

